// edit by sb
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this._drag = null;
        this._suppressClick = false;

        // ModalDialog closes media modals on mouse "pointerup".
        // Block it for everything except the close button.
        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.target.closest('.product-media-modal__toggle')) return;
            event.stopPropagation();
          },
          true
        );

        // Click on image = toggle zoom in / zoom out
        this.addEventListener('click', (event) => {
          if (this._suppressClick) {
            // this click was the end of a drag, not a real click
            this._suppressClick = false;
            return;
          }
          const img = event.target.closest('img');
          if (!img || !this.querySelector('.product-media-modal__content').contains(img)) return;
          this.toggleZoom(img, event);
        });

        // Drag to pan (mouse) while zoomed
        this.addEventListener('pointerdown', (event) => {
          if (!this.classList.contains('is-zoomed')) return;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          const container = this.querySelector('[role="document"]');
          if (!container || !container.contains(event.target)) return;

          this._drag = {
            x: event.clientX,
            y: event.clientY,
            left: container.scrollLeft,
            top: container.scrollTop,
            moved: false,
          };
          event.preventDefault(); // stop native image dragging
        });

        document.addEventListener('pointermove', (event) => {
          if (!this._drag) return;
          const container = this.querySelector('[role="document"]');
          const dx = event.clientX - this._drag.x;
          const dy = event.clientY - this._drag.y;

          if (!this._drag.moved && Math.abs(dx) + Math.abs(dy) > 5) {
            this._drag.moved = true;
            this.classList.add('is-dragging');
          }
          if (this._drag.moved) {
            container.scrollLeft = this._drag.left - dx;
            container.scrollTop = this._drag.top - dy;
          }
        });

        // capture phase so it still runs even though we block pointerup inside the modal
        document.addEventListener(
          'pointerup',
          () => {
            if (!this._drag) return;
            if (this._drag.moved) {
              this._suppressClick = true;
              setTimeout(() => (this._suppressClick = false), 0);
            }
            this._drag = null;
            this.classList.remove('is-dragging');
          },
          true
        );
      }

      hide() {
        this.classList.remove('is-zoomed', 'is-dragging');
        this._drag = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.classList.remove('is-zoomed', 'is-dragging');
        this.showActiveMedia();
      }

      toggleZoom(img, event) {
        const container = this.querySelector('[role="document"]');
        const rect = img.getBoundingClientRect();
        const xRatio = (event.clientX - rect.left) / rect.width;
        const yRatio = (event.clientY - rect.top) / rect.height;

        const zoomingIn = !this.classList.contains('is-zoomed');
        this.classList.toggle('is-zoomed', zoomingIn);

        requestAnimationFrame(() => {
          if (zoomingIn) {
            // center the fixed frame on the point the user clicked
            const newRect = img.getBoundingClientRect();
            const contRect = container.getBoundingClientRect();
            const offsetLeft = newRect.left - contRect.left + container.scrollLeft;
            const offsetTop = newRect.top - contRect.top + container.scrollTop;
            container.scrollLeft = offsetLeft + newRect.width * xRatio - container.clientWidth / 2;
            container.scrollTop = offsetTop + newRect.height * yRatio - container.clientHeight / 2;
          } else {
            // zoom out: go back to THIS image in the gallery
            container.scrollLeft = 0;
            img.scrollIntoView({ block: 'center', inline: 'center' });
          }
        });
      }

      showActiveMedia() {
        const openedId = this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${openedId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;

        // wait for the modal to render, then jump to the clicked image
        requestAnimationFrame(() => {
          activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}